import { EFinancingCompany } from '@if/core/types'
import { apiClient } from '@src/services/http-common'
import { Customer } from '@src/types/customer'
import { useQuery } from '@tanstack/react-query'

const getCustomer = async (customerId: number, financingCompanyId: EFinancingCompany) => {
  const response = await apiClient.get<Customer>(`${financingCompanyId}/customers/${customerId}`)
  return response.data
}

export const useGetCustomer = (customerId: number, financingCompanyId: EFinancingCompany) =>
  useQuery({
    queryKey: ['customers', financingCompanyId, customerId],
    queryFn: () => getCustomer(customerId, financingCompanyId),
  })
